/** GraphQL Query that check if JP delivery date is valid or not. */
export default `
  query isValidJpDeliveryDate($cart_id: String!) {
    isValidJpDeliveryDate(cart_id: $cart_id) {
      is_valid_jp_delivery_date
    }
  }
`;
